import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";
import Swal from "sweetalert2";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
};

export const initialAuthState = {
  user: undefined,
  accessToken: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v726-demo1-auth", whitelist: ["accessToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { accessToken } = action.payload;

        return { accessToken, user: undefined };
      }

      case actionTypes.Register: {
        const { accessToken } = action.payload;

        return { accessToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      default:
        return state;
    }
  }
);

export const selectUser = (state) => state.auth.user.data;

export const actions = {
  login: (accessToken) => ({
    type: actionTypes.Login,
    payload: { accessToken },
  }),
  register: (accessToken) => ({
    type: actionTypes.Register,
    payload: { accessToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));
    (async () => {
      const { value: accept } = await Swal.fire({
        title: "APL Website Privacy Policy",
        width: "80%",
        customClass: "swal-terms-container",
        html:
          '<div style="margin-bottom: 20px">' +
          '<p>BY accessing and/or using these web pages of PT Anugerah Pharmindo Lestari, referred to as "APL" you, as a user of the Site, hereby accept and agree to abide by the "APL Privacy Policy”.</p>' +
          "<p>This APL Privacy Policy is not intended to, nor does it, create any contractual rights whatsoever or any other legal rights, nor does it create any obligations on us in respect of any other party or on behalf of any party.</p>" +
          "<p>IF YOU DO NOT AGREE WITH ANY OF THE ABOVE, PLEASE DISCONTINUE YOUR USE OF THE SITE.</p>" +
          "</div>" +
          "<h4>Privacy Policy</h4>" +
          "<p>This Privacy Policy sets out the practices which APL has adopted in relation to the collection of information through this web site and our use of such information. By accessing and/or using our web site, you agree that we may gather information about you and your use of our web site and that we may use this information in accordance with this Privacy Policy. If you do not agree to this Privacy Policy, please discontinue your access immediately.</p>" +
          "<h5>Personal Information we collect</h5>" +
          "<ul>" +
          "<li>" +
          "<p>Generally, you can access and use the Site without disclosing any personally identifiable information.</p>" +
          "</li>" +
          "<li>" +
          "<p>Your personal information may be supplied by you or collected from you as a result of your access to or use of the Site at the following points:</p>" +
          "<ol>" +
          "<li>when you browse, use, participate in any activity or service on the Site or post any notice on the Site; and</li>" +
          "<li>when you respond to other online surveys, polls and purchases.</li>" +
          "</ol>" +
          "</li>" +
          "<li>" +
          "<p>APL respects the privacy of your personal information. Any personal information supplied by you or collected from you as a result of your access to or use of the Site will be used for the following purposes only:</p>" +
          "<ol>" +
          "<li>because it is necessary to enable you to access or use a service on the Site;</li>" +
          "<li>to identify you when you access and use the Site in order for you to enjoy a customised and personalised experience;</li>" +
          "<li>to update and enhance our records and to advise you of other products or services which may be of interest to you; and</li>" +
          "<li>to improve the design and marketing of our range of products and services for your use.</li>" +
          "</ol>" +
          "</li>" +
          "<li>" +
          "<p>If you submit personal information of another person to us for any particular purpose, you warrant and represent to us that you have obtained the consent of such person to provide us with the personal information for such purpose and that you are authorized to agree to this Privacy Policy on behalf of the person. You must ensure that all personal information submitted to us is complete, accurate, true and correct.</p>" +
          "</li>" +
          "<li>" +
          "<p>The use of your personal information will be kept to the minimum required in order for us to continually monitor and improve our services to our customers and keeping you informed about our products, services and other opportunities within APL.</p>" +
          "</li>" +
          "<li>" +
          "<p>Please note that you are given the option with respect to whether you agree to the foregoing collection, storage, use and disclosure of your personal information by us by choosing whether to submit the personal information or not. If you submit the personal information to us, we shall deem that as your consent and agreement to this APL Privacy Policy.</p>" +
          "</li>" +
          "<li>" +
          "<p>If you decide that you do not want APL to use your personal information or to share your personal information with third parties, you understand that this may in some cases impact on the availability of services and the quality of services that APL may provide to you and may mean that the services provided to you (if possible at all) by APL may not be customized for your use, may be less user- friendly and less efficient.</p>" +
          "</li>" +
          "</ul>" +
          "<h5>Our Internal Use of Your Personal Information</h5>" +
          "<ul>" +
          "<li>" +
          "<p>The personal information supplied by you or collected from you as a result of your access to or use of the Site may be transferred within the APL group of companies and to our service providers and data processors in different jurisdictions. Please note also that APL may use overseas facilities to process or back up its information. As a result, we transfer and store your personal information to our, our service providers, or our data processors overseas facilities. By using this Site you consent to such transfers.</p>" +
          "</li>" +
          "</ul>" +
          "<h5>Third Parties</h5>" +
          "<ul>" +
          "<li>" +
          "<p>Your personal information will not be disclosed by us to any third party, unless we have your permission or we are under a legal obligation or duty to do so, except for disclosure to the following individuals or entities which you agree to:</p>" +
          "<ol>" +
          "<li>other companies in the APL group of companies;</li>" +
          "<li>government authorities or regulators;</li>" +
          "<li>our professional advisers, including without limitation our lawyers, accountants and auditors;</li>" +
          "<li>our third party service providers (including those who provide payment, administrative or other services to us in connection with the operation of the Site and/or of our business) or data processors;</li>" +
          "<li>any agent acting on our behalf; and</li>" +
          "<li>our business alliance partners.</li>" +
          "</ol>" +
          "</li>" +
          "<li>" +
          "<p>In particular, we do not rent or sell your personal information to any third party (unless as part of the sale of our entire assets or sale of our business as a going concern).</p>" +
          "</li>" +
          "</ul>" +
          "<h5>Links</h5>" +
          "<ul>" +
          "<li>" +
          '<p>The Site may contain links to other web sites, including web sites belonging to our affiliates (the"Linked Sites"). The Linked Sites are not under the control of APL and APL is not responsible for any Linked Sites. You should note that any personal information that you provide to the Linked Sites are not subject to the APL Privacy Policy, and we strongly recommend that you be aware of their privacy and security policies.</p>' +
          "</li>" +
          "</ul>" +
          "<h5>Cookies</h5>" +
          "<ul>" +
          "<li>" +
          '<p>In order to improve our services to you, we also use automated tracking devices such as a "cookie". A cookie is a small amount of data that our Web server sends to your Web browser when you visit certain parts of our Site and the use of which is intended to assist our understanding of your interest in our Site. However, you can always choose to disable cookies from being stored on your computer by changing your browser settings. Disabling cookies, however, may result in a limited experience of our functionality and services and in some cases may mean that we are unable to provide you with the services, or parts of the services, that you have requested. Some of our business partners whose content is incorporated into or linked to from the Site may also use cookies. However, we have no access to or control over these cookies.</p>' +
          "</li>" +
          "</ul>" +
          "<h5>Security</h5>" +
          "<ul>" +
          "<li>" +
          "<p>We wish to assure you that your personal information will be treated with high standards of security. APL will endeavor to take all reasonable steps to keep secure any information which we hold about you. Your personal information is stored on secure servers. Unfortunately, despite the aforementioned technology and security features, no data transmission over the Internet can be guaranteed to be 100% secure, so we cannot give an absolute assurance that the information you provide to us will be secure at all times, and we cannot be responsible for event arising from unauthorized access to your personal information. APL will not be held responsible for events arising from third parties gaining unauthorized access to your personal information.</p>" +
          "</li>" +
          "</ul>" +
          "<h5>Updating your Personal Information and contacting APL</h5>" +
          "<ul>" +
          "<li>" +
          '<p>Depending on where you are situated, you may have the legal right to request access to and correction of personal information about you held by us. If you have that right and you wish to access or have the right to ask for correction or deletion of any of your personal data held by us, or if you have any questions concerning this APL Privacy Policy, please contact our:<br/><div style="margin-top: 10px;font-weight: normal">Data Privacy Officer<br/>Email: APLDataPrivacy@aplcare.com<br/>Tel: +62 21 3456008<br/>Fax: +62 21 3456088</div></p>' +
          "</li>" +
          "<li>" +
          "<p>We will only withhold your access to your personal information in extremely limited circumstances, such as:</p>" +
          "<ol>" +
          "<li>where it might be dangerous if you were to have it;</li>" +
          "<li>where it might prejudice an investigation currently underway;</li>" +
          "<li>where it relates to court proceedings and may be subject to the discovery process;</li>" +
          "<li>where it may relate to a commercially sensitive decision-making process; or</li>" +
          "<li>where other individuals' personal information is contained in the same record.</li>" +
          "</ol>" +
          "</li>" +
          "<li>" +
          "<p>Naturally, we offer you the ability to opt out of receiving information of our products and services at the point of collection or by e-mailing us at APLDataPrivacy@aplcare.com or writing to us at Cowell Tower 12th Floor, Jl. Senen Raya No.135, Jakarta Pusat, Indonesia. Your request will be processed in 10 business days upon receipt of e-mail or written request.</p>" +
          "</li>" +
          "<li>" +
          "<p>If you do not want us to use your personal information or to share your personal information with third parties, please e-mail us at APLDataPrivacy@aplcare.com or please write to us at Cowell Tower 12th Floor, Jl. Senen Raya No.135, Jakarta Pusat, Indonesia.</p>" +
          "</li>" +
          "</ul>" +
          "<h5>Changes to our Privacy Policy</h5>" +
          "<ul>" +
          "<li>" +
          "<p>APL reserves the right in its sole and absolute discretion to modify without prior warning or notice this Privacy Policy. You agree that your continued use of the Site after such modification shall constitute an affirmative acknowledgement by you of the modifications and agreement by you to abide and be bound by such modifications. As such, APL recommends and advises you to visit this web page to review the prevailing Privacy Policy on the Site.</p>" +
          "</li>" +
          "</ul>",
        input: "checkbox",
        allowOutsideClick: false,
        inputValue: 0,
        inputPlaceholder: "I agree to the terms and conditions",
        confirmButtonText: "Agree",
        inputValidator: (result) => {
          return !result && "You need to agree with T&C";
        },
      });

      // if (accept) {
      //   Swal.fire('You agreed with T&C :)')
      // }
    })();
  });
}
